import { memo } from 'react';
import { arrayOf, node, oneOfType } from 'prop-types';

export const Section = ({ children = null, ...props }) => <section {...props}>{children}</section>;

Section.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
};

export const MemoizedSection = memo(Section);
